<template>
  <div class="scence usercenterUnusualDataReport">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="desc left">起止时间:</span>
          <div style="display: inline-block">
            <el-date-picker
              v-model="query.begTime"
              format="yyyy-MM-dd HH:00"
              value-format="yyyy-MM-dd HH:00"
              type="datetime"
              placeholder="选择开始时间"
              :clearable="false"
              :editable="false"
               :picker-options="Global.pickerOptionsStart(query.endTime)"
            ></el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="query.endTime"
              format="yyyy-MM-dd HH:00"
              value-format="yyyy-MM-dd HH:00"
              type="datetime"
              placeholder="选择结束时间"
              :clearable="false"
              :editable="false"
              :picker-options="Global.pickerOptionsEnd(query.begTime)"
            ></el-date-picker>
          </div>
            <span class="type-txt">类型:</span>
            <div class="selectContent" style="display: inline-block">
                 <el-select v-model="typeValue" clearable filterable placeholder="请选择" @change="Global.emptyQuery(typeValue,searchData)">
                <el-option
                    v-for="(item,i) in typeList"
                    :key="i"
                    :label="item.name"
                    :value="item.type">
                  </el-option>
              </el-select>
        </div>
           <span id="search" @click="searchData">查询</span>
            <span id="export" @click="exportExcel">
            <span class="export-icon"></span>导出
          </span>
          <span id="setWater" @click="onConfigWater(1)"
            ><span class="setWater-icon"></span>水位值设置</span>
           <span
            id="setRain" @click="onConfigRain(2)"
            ><span class="setRain-icon"></span>雨量值设置</span>
            <span
            id="exportProlem" @click="exportProblemStation"
            ><span class="exportProlem-icon"></span>缺报数据导出</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table
              :data="tdata"
              border
              fit
              highlight-current-row
              :max-height="height"
              style="width: 100%"
              v-loading="loading"
            >
              <el-table-column
                type="index"
                width="80"
                align="center"
                label="序号"
              ></el-table-column>
              <el-table-column
                align="center"
                label="站码"
                prop="stcd"
              ></el-table-column>
              <el-table-column
                align="center"
                label="站名"
                prop="stnm"
              ></el-table-column>
              <el-table-column
                align="center"
                label="时间"
                prop="time"
              >
              </el-table-column>
               <el-table-column
                align="center"
                label="水位"
                prop="water"
              ></el-table-column>
              <el-table-column
                align="center"
                label="雨量"
                prop="rain"
              ></el-table-column>
              <el-table-column
                align="center"
                label="监测类型"
              >
                <template slot-scope="scope">
                  <span>{{formatztflag(scope.row)}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 水位设置 -->
        <el-dialog
          :title="diagTitleWater"
          :visible.sync="diagShowWater"
          :close-on-click-modal="false"
          width="35%"
        >
          <el-form
            ref="waterForm"
            :rules="waterRules"
            :model="waterForm"
            label-width="100px"
          >
            <div class="formContent">
                <el-form-item label="水位值" required prop="water">
                  <el-input
                    v-model="waterForm.water"
                    placeholder="请输入水位值"
                  ></el-input>
                </el-form-item>
            </div>
            <span style="color:red;display:block;margin-left:1.3rem;">注：该水位值表示用户设置5分钟水位超过{{waterForm.water}}m为异常数据。</span>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="diagShowWater = false">取消</el-button>
            <el-button type="primary" @click="onSaveWater">保存</el-button>
          </div>
        </el-dialog>
        <!-- 雨量值设置 -->
        <el-dialog
          :title="diagTitleRain"
          :visible.sync="diagShowRain"
          :close-on-click-modal="false"
          width="35%"
        >
          <el-form
            ref="rainForm"
            :rules="rainRules"
            :model="rainForm"
            label-width="100px"
          >
            <div class="formContent">
                <el-form-item label="雨量值" required prop="rain">
                  <el-input
                    v-model="rainForm.rain"
                    placeholder="请输入雨量值"
                  ></el-input>
                </el-form-item>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="diagShowRain = false">取消</el-button>
            <el-button type="primary" @click="onSaveRain">保存</el-button>
          </div>
          <span style="color:red;display:block;margin-left:1.3rem;">注：该雨量值表示用户设置5分钟雨量超过{{rainForm.rain}}mm为异常数据。</span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import reportAnalysisTypes from '@/store/types/reportAnalysis'
// import config from '@/config'
export default {
  data () {
    return {
      height: 10,
      tdata: [],
      loading: false,
      query: {
        type: '',
        begTime: '',
        endTime: ''
      },
      typeValue: '',
      typeList: [
        { name: '水位', type: 1 },
        { name: '雨量', type: 2 }
      ],
      diagShowWater: false,
      diagTitleWater: '水位值设置',
      diagShowRain: false,
      diagTitleRain: '雨量值设置',
      waterForm: {},
      rainForm: {},
      waterRules: {
        water: [{ required: true, message: '水位值不能为空' }]
      },
      rainRules: {
        rain: [{ required: true, message: '雨量值不能为空' }]
      }
    }
  },
  methods: {
    formatztflag (row, column) {
      let showstr = ''
      if (row.sttp && row.sttp.includes(',')) {
        let arr = row.sttp.split(',')
        arr.forEach(item => {
          switch (item) {
            case 'MM':
              item = '气象'
              break
            case 'BB':
              item = '蒸发'
              break
            case 'DD':
              item = '堰闸水文'
              break
            case 'TT':
              item = '潮位'
              break
            case 'DP':
              item = '泵站'
              break
            case 'SS':
              item = '墒情'
              break
            case 'PP':
              item = '雨量'
              break
            case 'ZZ':
              item = '河道'
              break
            case 'RR':
              item = '水库'
              break
            case 'ZG':
              item = '地下水'
              break
            case 'ZB':
              item = '分洪水位站'
              break
            default:
              break
          }
          showstr += item + ','
        })
        return showstr.slice(0, showstr.length - 1)
      } else {
        switch (row.sttp) {
          case 'MM':
            showstr = '气象'
            break
          case 'BB':
            showstr = '蒸发'
            break
          case 'DD':
            showstr = '堰闸水文'
            break
          case 'TT':
            showstr = '潮位'
            break
          case 'DP':
            showstr = '泵站'
            break
          case 'SS':
            showstr = '墒情'
            break
          case 'PP':
            showstr = '雨量'
            break
          case 'ZZ':
            showstr = '河道'
            break
          case 'RR':
            showstr = '水库'
            break
          case 'ZG':
            showstr = '地下水'
            break
          case 'ZB':
            showstr = '分洪水位'
            break
          default:
            break
        }
        return showstr
      }
    },
    searchData () {
      this.onLoadData()
    },
    onLoadData () {
      this.loading = true
      this.$store
        .dispatch(reportAnalysisTypes.GET_ABNORMAL_DATA, {
          Type: this.typeValue,
          BeginTime: this.query.begTime,
          EndTime: this.query.endTime
        })
        .then((data) => {
          this.tdata = data.rows
          this.loading = false
        })
    },
    exportExcel () {
      // this.$store
      //   .dispatch(reportAnalysisTypes.EXPORT_PERSONLIST, {
      //     Type: this.typeValue,
      //     BeginTime: this.query.begTime,
      //     EndTime: this.query.endTime
      //   })
      //   .then(data => {
      //     window.open(`${config.ApiYJ}${data.data}`)
      //     this.loading = false
      //   })
    },
    onConfigWater (type) {
      this.diagShowWater = true
      this.waterForm = {}
      this.$store
        .dispatch(reportAnalysisTypes.GET_ABNORMAL_VAVAL, {
          Type: type
        })
        .then((data) => {
          this.waterForm = Object.assign({}, { water: data.detail })
        })
    },
    onConfigRain (type) {
      this.diagShowRain = true
      this.rainForm = {}
      this.$store
        .dispatch(reportAnalysisTypes.GET_ABNORMAL_VAVAL, {
          Type: type
        })
        .then((data) => {
          this.rainForm = Object.assign({}, { rain: data.detail })
        })
    },
    onSaveWater () {
      this.$refs['waterForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch(reportAnalysisTypes.SAVE_GET_ABNORMAL_DATA, { Value: this.waterForm.water, Type: 1 })
            .then(() => {
              this.loading = false
              this.diagShowWater = false
              this.$notify.success({ title: '成功', message: '保存水位值成功.' })
              this.onLoadData()
            })
            .catch(() => {
              this.$notify.error({ title: '成功', message: '保存水位值失败.' })
              this.loading = false
            })
        }
      })
    },
    onSaveRain () {
      this.$refs['rainForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch(reportAnalysisTypes.SAVE_GET_ABNORMAL_DATA, { Value: this.rainForm.rain, Type: 2 })
            .then(() => {
              this.loading = false
              this.diagShowRain = false
              this.$notify.success({ title: '成功', message: '保存雨量值成功.' })
              this.onLoadData()
            })
            .catch(() => {
              this.$notify.error({ title: '成功', message: '保存雨量值失败.' })
              this.loading = false
            })
        }
      })
    },
    getTime () {
      let date = new Date()
      let preDate
      preDate = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000)
      this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD HH:00')
      this.query.endTime = this.$moment(date).format('YYYY-MM-DD HH:00')
    },
    exportProblemStation() {
      this.loading = true
      this.$store.dispatch(reportAnalysisTypes.EXPORT_PROBLEM_STATION, {}).then((data) => {
        window.location.href = this.Global.basePath + data.data
        // this.$notify.success({ title: '成功', message: '导出缺报数据成功.' })
        this.loading = false
      }).catch(() => {
        this.$notify.error({ title: '失败', message: '导出缺报数据失败.' })
        this.loading = false
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', {
      name: this.$route.meta,
      type: this.$route.name
    })
  },
  mounted () {
    this.getTime()
    this.onLoadData()
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      this.height =
        this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/reportanalysis.less" scoped></style>
<style lang="less" scoped>
.usercenterUnusualDataReport {
  .formContent {
    display: flex;
    justify-content: space-between;
    /deep/ .el-form-item {
      width: 98%;
    }
  }
  .desc.left {
      margin-left: 17px;
    }
   #search{
      padding: 10px 18px;
      background-color: #3d72fb;
      cursor: pointer;
      font-size:16px;
      color: #ffffff;
      border-radius: 3px;
      margin-left: 13px;
    }
  .type-txt{
      width: 60px;
      height: 35px;
      font-size:16px;
      font-family:Microsoft YaHei UI;
      line-height: 40px;
      margin-left: 20px;
      margin-right:5px;
  }
   #export{
    padding: 8px 8px;
    background-color: #3e81fc;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #4d8cff;
    }
    .export-icon{
      width: 18px;
      height: 17px;
      display: inline-block;
      background-image: url('~@/assets/monitorimg/export.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 5px;
  }
  }
   #setRain{
    padding: 9px 9px;
    background-color: #44AA44;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #67c23a;
    }
      .setRain-icon{
      width: 18px;
      height: 17px;
      display: block;
      background-image: url('~@/assets/monitorimg/edit.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 5px;
      float: left;
      margin-top: 2px;
    }
  }
   #setWater{
    padding: 9px 9px;
    background-color: #27b6e2;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #12a0cc;
    }
      .setWater-icon{
        width: 18px;
        height: 17px;
        display: block;
        background-image: url('~@/assets/monitorimg/edit.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-right: 5px;
        float: left;
        margin-top: 2px;
    }
  }
  #exportProlem{
    padding: 8px 8px;
    background-color: #3e81fc;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #4d8cff;
    }
    .exportProlem-icon{
      width: 18px;
      height: 17px;
      display: inline-block;
      background-image: url('~@/assets/monitorimg/export.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 5px;
  }
  }
}
</style>
